import lodashFind from 'lodash/find'
import { SERVER_ENVIRONMENT_LIST } from './legacy-constants'
import { ScopeServerBase } from './legacy-server-settings-controller'
import { StacktraceCaptureMode } from '../../../components/servers-grid/shared'
import { GetOrgSettingsBaseResp } from './legacy-server-factory'
import { LogLevelDisplay } from '../../../components/server-settings/form-components/log-level-input'

export const serverDisplayLogLevels: LogLevelDisplay[] = [
  'Error',
  'Warn',
  'Info',
  'Debug',
  'Trace'
]

export const stackTraceCaptureModes: StacktraceCaptureMode[] = [
  'ALL',
  'SOME',
  'NONE',
  'SINK'
]

// Used in legacy and new syslog code
// Map API response to UI state
export const buildServerSettingsFormCommon: (
  settings: GetOrgSettingsBaseResp
) => ScopeServerBase = (settings) => {
  const environment = lodashFind(SERVER_ENVIRONMENT_LIST, (item) => {
    return item.value === settings.environment
  })
  if (!environment) {
    throw new Error('could not find matching environment item')
  }
  return {
    assess: settings.assess,
    defend: settings.defend,
    environment,
    logLevel: (settings.log_level.charAt(0).toUpperCase() +
      settings.log_level.substr(1).toLowerCase()) as LogLevelDisplay,
    sampling: settings.sampling,
    stacktrace: settings.stacktrace_capture_mode,
    baseline: settings.sampling_baseline,
    frequency: settings.sampling_frequency,
    window: settings.sampling_window,
    botProtection: settings.bot_protection,
    syslog_severity_exploited_selected: true,
    autoLicenseProtection: settings.auto_license_protection,
    syslog_enabled: settings.syslog_enabled,
    server_cleanup_policy: settings.server_cleanup_policy
  }
}
